/* Action creators are function that return an action object or a function that returns a promise whihc dispatch the resolved action */

import {
  MEAT_PROTEIN_TAG_GROUP,
  SEAFOOD_PROTEIN_TAG_GROUP,
  PLANT_PROTEIN_TAG_GROUP,
} from '../constants/constants';
import { getApiV2Tags } from '@hungryroot/rest';

import * as actions from './actions';
import {
  getFilteredProducts,
  getFilteredRecipes as gFR,
} from '../api/customize_api';
import { getPairingDishtypes, getProductCategories, getTags } from '../api/api';
import {
  orderId,
  allSpecialFilterKey,
  sortByOptions,
  customerId,
} from './const';
import { createTagDietFilterFunc, createSelectorOptions } from '../utils/utils';
import { scrollItemsContainerToTop, scrollSideBar } from '../utils/utils';

export const openFilterMenu = () => {
  scrollSideBar();
  return { type: actions.OPEN_FILTER_MENU };
};

export const closeFilterMenu = () => {
  return { type: actions.CLOSE_FILTER_MENU };
};

export const getDishtypes = () => {
  return (dispatch) => {
    getPairingDishtypes().then((dishtypes) => {
      dispatch({
        type: actions.GET_DISHTYPES,
        dishtypes: dishtypes,
      });
    });
  };
};

export const getCategories = () => {
  return (dispatch) => {
    getProductCategories().then((categories) => {
      dispatch({
        type: actions.GET_CATEGORIES,
        categories: categories,
      });
    });
  };
};

// Filters action creators

export const toggleSkuFilter = (filter, filterCategory) => {
  return {
    type: actions.TOGGLE_SKU_FILTER,
    filter: filter,
    filterCategory: filterCategory,
  };
};

export const toggleRecipeFilter = (filter, filterCategory) => {
  return {
    type: actions.TOGGLE_RECIPE_FILTER,
    filter: filter,
    filterCategory: filterCategory,
  };
};

export const changeSorting = (sorting) => {
  return {
    type: actions.CHANGE_SORTING,
    sorting: sorting,
  };
};

//helper function to set Params from a filter array
const setFromArray = (filterArr, params) =>
  filterArr.forEach((filter) => (params[filter] = 1));

export const getFilteredSkus = (loadMore = false) => {
  return (dispatch, getState) => {
    let filters = getState().filters.appliedSkuFilters;
    let categoryId = getState().filters.selectedSkuCategory;
    let searchText = getState().filters.searchText;
    let sorting = getState().filters.sorting;
    let params = { order_id: orderId };
    setFromArray(filters.featured, params);
    // setFromArray(filters.protein, params);
    setFromArray(filters.dietary, params);
    setFromArray(filters.occasion, params);
    // replace proteins with tags:
    params['tags'] = filters.protein.join(',');
    if (filters.spicy_level.length)
      params['spicy_level'] = filters.spicy_level.join(',');
    // set it from dietary:
    if (categoryId && categoryId !== allSpecialFilterKey)
      params['category_id'] = categoryId;
    if (searchText) {
      params['search_query'] = searchText;
    }
    if (loadMore) {
      params['offset'] = getState().filters.skus.length;
    } else {
      params['includes'] = 'total_count,category_count';
    }
    if (sorting) {
      params[sortByOptions[sorting]['value']] = 1;
    }
    getFilteredProducts(params)
      .then((data) => {
        dispatch({
          type: actions.GET_FILTERED_SKUS,
          skus: data.products,
          totalCount: data.total_count,
          categoryCount: data.category_count,
          loadMore: loadMore,
        });
      })
      .catch((error) => {
        console.error(error);
        dispatch({
          error,
          type: actions.TOGGLE_ERROR_MODAL,
        });
      });
  };
};

export const getFilteredRecipes = (loadMore = false) => {
  return (dispatch, getState) => {
    let filters = getState().filters.appliedRecipeFilters;
    let dishTypeId = getState().filters.selectedDishType;
    let searchText = getState().filters.searchText;
    let sorting = getState().filters.sorting;
    let params = { order_id: orderId, customer_id: customerId };
    setFromArray(filters.favorite, params);
    setFromArray(filters.featured, params);
    // setFromArray(filters.protein, params);
    setFromArray(filters.dietary, params);
    // replace proteins with tags:
    params['tags'] = filters.protein.join(',');
    // set params from values
    if (filters.max_calories) params['max_calories'] = filters.max_calories;
    if (filters.max_cooking_time)
      params['max_cooking_time'] = filters.max_cooking_time;
    if (filters.spicy_level.length)
      params['spicy_level'] = filters.spicy_level.join(',');
    if (dishTypeId && dishTypeId !== allSpecialFilterKey)
      params['dish_type_id'] = dishTypeId;
    if (filters.serving_size) {
      params['serving_size'] = filters.serving_size;
    }
    if (searchText) {
      params['search_query'] = searchText;
    }
    if (loadMore) {
      params['offset'] = getState().filters.recipes.length;
    } else {
      if (orderId || customerId) {
        params['includes'] = 'all';
        params.no_cache = 1;
      } else params['includes'] = 'total_count,dish_type_count,favorites';
    }
    if (sorting) {
      params[sortByOptions[sorting]['value']] = 1;
    }

    gFR(params)
      .then((data) => {
        dispatch({
          type: actions.GET_FILTERED_RECIPES,
          recipes: data.pairings,
          totalCount: data.total_count,
          dishTypeCount: data.dish_type_count,
          loadMore: loadMore,
        });
      })
      .catch((error) => {
        console.error(error);
        dispatch({
          error,
          type: actions.TOGGLE_ERROR_MODAL,
        });
      });
  };
};

export const clearRecipeFilters = (category = null) => {
  scrollItemsContainerToTop();
  return {
    type: actions.CLEAR_RECIPE_FILTERS,
    category: category,
  };
};

export const applyRecipeFilters = () => {
  scrollItemsContainerToTop();
  return {
    type: actions.APPLY_RECIPE_FILTERS,
  };
};

export const clearSkuFilters = (category = null) => {
  scrollItemsContainerToTop();
  return {
    type: actions.CLEAR_SKU_FILTERS,
    category: category,
  };
};

export const applySkuFilters = () => {
  scrollItemsContainerToTop();
  return {
    type: actions.APPLY_SKU_FILTERS,
  };
};

export const selectSkuCategory = (category) => {
  return {
    type: actions.SELECT_SKU_CATEGORY,
    category: category,
  };
};

export const selectRecipeDishtype = (dishType) => {
  return {
    type: actions.SELECT_RECIPE_DISHTYPE,
    dishType: dishType,
  };
};

export const getTagOptions = (dietaryPreferences = {}) => {
  return (dispatch) => {
    // Returns tags for the below tag groups
    getApiV2Tags({
      tag_group__in: [
        MEAT_PROTEIN_TAG_GROUP,
        SEAFOOD_PROTEIN_TAG_GROUP,
        PLANT_PROTEIN_TAG_GROUP,
      ],
    }).then((response) => {
      const tags = response.data.results;
      const filteredTags = createTagDietFilterFunc(dietaryPreferences)(tags);
      dispatch({
        type: actions.GET_TAGS,
        tagOptions: createSelectorOptions(filteredTags, 'id', 'name'),
        tagOptionsOrder: filteredTags.map((t) => t.id),
      });
    });
  };
};

export const openVolumeModal = () => {
  return {
    type: actions.OPEN_VOLUME_MODAL,
  };
};

export const closeVolumeModal = () => {
  return {
    type: actions.CLOSE_VOLUME_MODAL,
  };
};

export const openColdVolumeModal = () => {
  return {
    type: actions.OPEN_COLD_VOLUME_MODAL,
  };
};

export const closeColdVolumeModal = () => {
  return {
    type: actions.CLOSE_COLD_VOLUME_MODAL,
  };
};

export const updateSearchText = (searchText) => {
  return {
    type: actions.UPDATE_SEARCH_TEXT,
    text: searchText,
  };
};
